import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import {
	brandPrimaryHover,
	brandPrimaryText,
	brandSecondary,
	destructiveHover,
	header,
	label,
	mention,
	titles,
} from '../../styles/colors';
import { CssSelectors, Layouts } from '../../styles/styles';

const { spacing, common, typography } = THEME;

const fadeInKeyframes = {
	'0%': {
		opacity: 0,
	},
	'100%': {
		opacity: 1,
	},
};

export const styleSheet = StyleSheet.create({
	plannedCampaignListItem: {
		animationDelay: 'calc(var(--stagger-anim-order) * 100ms)',
		animationDuration: '300ms',
		animationFillMode: 'forwards',
		animationIterationCount: 1,
		animationName: [fadeInKeyframes],
		animationTimingFunction: 'ease-in-out',
		opacity: 0,
	},
	scheduleTypeDropDown: {
		...CssSelectors.allChildren(
			{
				minWidth: 120,
			},
			'.select-box-menu'
		),
	},
	timeDropdown: {
		...CssSelectors.allChildren(
			{
				maxWidth: 150,
				minWidth: 120,
			},
			'.select-box-menu'
		),
	},
	emailFallbackInfo: {
		alignItems: 'center',
		background: mention,
		borderRadius: 3,
		color: brandPrimaryText,
		display: 'flex',
		fontSize: typography.fontSizes.xs,
		fontStyle: 'italic',
		justifyContent: 'center',
		padding: '1rem 0.5rem',
		...CssSelectors.allChildren(
			{
				marginLeft: '0.5rem',
			},
			':not(:first-child)'
		),
	},
	modalBodyText: {
		color: label,
		fontSize: typography.fontSizes.sm,
		lineHeight: '18px',
		marginTop: '0.5rem',
	},
	recipientsHeader: {
		...Layouts.verticalStack(20),
		boxSizing: 'border-box',
		padding: '30px 0 10px 0',
	},
	recipientsHeaderTitle: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		fontSize: typography.fontSizes.lg,
		justifyContent: 'space-between',
	},
	recipientsListItemAvatar: {
		flexShrink: 0,
		marginLeft: '0.5rem',
	},
	recipientsListItemDetailsCompanyName: {
		color: header,
		fontSize: typography.fontSizes.sm,
		marginBottom: '0.5rem',
		marginTop: '0.25rem',
	},
	recipientsListItemDetailsName: {
		color: titles,
		fontSize: typography.fontSizes.lg,
		lineHeight: '22px',
	},
	labelRequired: {
		'::after': {
			color: destructiveHover,
			content: '"*"',
			display: 'inline',
			marginLeft: '0.25rem',
		},
	},
	searchEmployeeBox: {
		fontSize: typography.fontSizes.sm,
		marginTop: '1rem',
	},
	showingFilterDropdownTrigger: {
		background: '#fff',
		color: '#858585',
		fontSize: typography.fontSizes.sm,
	},
	showingHeaderOptions: {
		color: '#858585',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: typography.fontSizes.sm,
		marginBottom: '0.5rem',
	},
	tagPointDown: {
		transform: 'rotateZ(90deg)',
	},
	tagPointUp: {
		transform: 'rotateZ(270deg)',
	},
	tagTokenContainer: {
		maxHeight: 'unset',
		...CssSelectors.allChildren({
			marginLeft: '0.5rem',
		}),
	},
	title: {
		color: brandSecondary,
		fontSize: 22,
		fontWeight: 600,
		maxWidth: '80%',
	},
	editorWrapper: {
		borderBottomLeftRadius: common.borderRadius,
		borderBottomRightRadius: common.borderRadius,
		overflow: 'hidden',
		padding: '8px 12px',
		minHeight: 280,
	},
	toolbar: {
		alignItems: 'center',
		borderBottom: '1px solid #d1d5db',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '8px 12px',
	},
	toolbarLeft: {
		alignItems: 'center',
		display: 'flex',
		gap: 12,
	},
	characterCount: {
		color: '#9ca3af',
		fontSize: typography.fontSizes.sm,
	},
	toolbarDivider: {
		width: 1,
		backgroundColor: '#d1d5db',
		marginTop: -8,
		marginBottom: -8,
		alignSelf: 'stretch',
	},
	attachmentsContainer: {
		alignItems: 'flex-end',
		backgroundColor: '#fff',
		border: '1px solid #d1d5db',
		borderRadius: common.borderRadius,
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
		boxSizing: 'border-box',
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.sm,
		marginBottom: 12,
		padding: spacing.sm,
	},
	imageAttachmentWrapper: {
		position: 'relative',
	},
	attachmentImagePreview: {
		borderRadius: common.borderRadius,
		maxHeight: 240,
		maxWidth: 240,
		objectFit: 'cover',
		width: '100%',
	},
	attachmentCloseButton: {
		position: 'absolute',
		right: spacing.xs,
	},
	fileAttachmentContainer: {
		alignItems: 'center',
		backgroundColor: '#e5e7eb',
		boxSizing: 'border-box',
		display: 'flex',
		gap: spacing.sm,
		padding: `${spacing.xs}px ${spacing.sm}px`,
	},
	fileAttachmentName: {
		boxSizing: 'border-box',
		color: brandPrimaryHover,
		fontSize: typography.fontSizes.sm,
	},
	canSpamDisclaimer: {
		color: header,
		fontSize: typography.fontSizes.xs,
		fontStyle: 'italic',
		textAlign: 'right',
	},
	editorContainer: {
		backgroundColor: '#fff',
		border: '1px solid #d1d5db',
		borderRadius: common.borderRadius,
		marginBottom: 12,
	},
	editorContainerWithAttachments: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},
});
